var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.onlyMercapromo)?_c('home-mercapromo'):_c('home-cbm')}
var staticRenderFns = []

export { render, staticRenderFns }